// Application Shell
import {Shell} from '@/entryPoints/b2c/shell';

import '@sassRoot/entryPoints/b2c/bike-finder.scss';

const bikeFinder = new Shell();
bikeFinder.initializeVue();

// Legacy foundation initialization
$(document).foundation();

$(document).ready(() => {
  bikeFinder.globalDocumentReadyInits();
});

$(window).on('load', () => {
  bikeFinder.globalOnLoadInits();
});
